import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DatabaseService, DialogService, WebserviceService} from '@wms/app/services';
import { WmsMessageComponent } from '@wms/app/components/wms-message/wms-message.component'

import {
  BaseComponent,
  WmsDialogBodyComponent,
  WmsDialogComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent
} from '@wms/app/components';
import {ProjectUpdatesService} from "@wms/app/project-updates/services/project-updates/project-updates.service";

@Component({
    selector: 'wms-source-code-updates-dialog',
    standalone: true,
    templateUrl: './source-code-updates.component.html',
    styleUrls: ['./source-code-updates.component.less'],
    imports: [
        CommonModule,
        WmsDialogComponent,
        WmsDialogHeaderComponent,
        WmsDialogBodyComponent,
        WmsDialogFooterComponent,
        WmsMessageComponent
    ]
})
export class SourceCodeUpdatesComponent extends BaseComponent {
  @Input() sourceCodeUpdates:any[] = [];
  private projectDetails: any;
  disableDialogActions: boolean = false;
  statusMessages:any

  projectUpdatesService= inject(ProjectUpdatesService);
  private databaseService = inject(DatabaseService);
  private webserviceService = inject(WebserviceService);
  private dialogService = inject(DialogService);

  constructor() {
    super()
  }

  ngOnInit(){
    this.projectDetails = this.projectService.getDetails();
  }

  updateSourceCode(service: any) {
    this.disableDialogActions = true;
    this.statusMessages = {"caption": this.locale.MESSAGE_PROGRESS_CODEGEN_DATABASE_DESC, "type": "loading"};
    if(service.type === 'RE_IMPORT_DB') {
      this.databaseReimport(service);
    } else {
      this.updateWebService(service);
    }
  }

  private databaseReimport(service: any) {
    this.databaseService.reImportDB( {
      projectID  : this.projectDetails.id,
      serviceId  : service.data.serviceId,
      retainDraft: true,
      reInitialize: true
    }).then(this.successCb.bind(this, service), this.errorCb.bind(this));
  }

  private updateWebService(service: any) {
    this.webserviceService.updateSource({
      projectId  :this.projectDetails.id,
      serviceId  : service.data.serviceId
    }).then(this.successCb.bind(this, service), this.errorCb.bind(this));
  }

  private successCb(service: any){
    service.resolved = true;
    this.disableDialogActions = false;
    this.statusMessages = null;
    this.projectUpdatesService.updatesInfo.sourceCodeUpdatesCount--;
    if(!this.projectUpdatesService.updatesInfo.sourceCodeUpdatesCount) {
      this.projectUpdatesService.updatesInfo.updatesCount--;
    }
  }

  private errorCb() {
    this.disableDialogActions = false;
    this.statusMessages = null;
  }

  closeDialog(){
    this.dialogService.close("sourceCodeUpdatesDialog");
  }
}
